import { IProduct } from './data/model';
import Vue from 'vue';
import Vuex from 'vuex';
import { products } from './data/products';
import { uiTranslations }  from './data/i18n';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        language: 'eng',
        products,
        uiTranslations
    },
    getters: {
        productsByLanguage(state) {
            if (state != null) {
                return state.products[state.language];
            }
            return null;
        },
        i18n(state) {
            if (state != null) {
                return state.uiTranslations[state.language];
            }
            return null;
        },
    },
    mutations: {
        setLanguage(state, lang) {
            state.language = lang;
        },
    },
    actions: {

    },
});
